<template>
  <v-app-bar
    color="white"
    clipped-left
    class="rai-content-toolbar"
    height="64px"
  >
    <div class="rai-project-name-box">
      <h3 style="color: #092b86; width: 142px;">{{ projectName }}</h3>
    </div>
    <v-divider
      v-if="title !== ''"
      class="mx-3"
      vertical
    />
    <h3 class="text-uppercase">{{ title }}</h3>

    <v-spacer/>
    <slot></slot>
    <v-switch
      v-model="showLogicalLangage"
      class="float-right mt-5"
      :label="showLogicalLangage ? $t('global.showLogicalLangage') : $t('global.showNaturalLangage')"
    />
  </v-app-bar>
</template>

<script>
import userRightMixin from '@/mixins/user-right-mixin.js';
import {UPDATE_SHOW_LOGICAL_LANGAGE} from '@/store/mutation-types';

export default {
  name: 'PageContentToolbar',

  mixins: [ userRightMixin ],

  computed: {
    showLogicalLangage: {
      get () {
        return this.$store.state.showLogicalLangage;
      },

      set (value) {
        this.$store.commit(UPDATE_SHOW_LOGICAL_LANGAGE, value);
      },
    }
  },

  props: {
    projectName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style>
.rai-content-toolbar .v-toolbar__content {
  margin-left: -170px;
  background-color: white;
  z-index: 3;
}

.rai-content-toolbar {
  box-shadow: none;
  box-shadow: 0 2px 2px -2px gray;
  position: sticky;
  top: 64px;
  z-index: 4;
}

.rai-project-name-box {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>